import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import CheckBox from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank'
import React, { useState } from 'react'

/** @notExported  */
interface RegularCheckboxProps {
  /** The checked state of the checkbox. */
  checked: boolean
  /** The function to call when the checkbox is changed. */
  onChange: (item: boolean) => void
  /** The label to display next to the checkbox. */
  label?: string
  /** Element ID. */
  id?: string
  /** Accessible label override. */
  ariaLabel?: string
}

/**
 * Regular checkbox component.
 *
 * @returns The regular checkbox component.
 * @notExported
 */
const RegularCheckbox: React.FC<RegularCheckboxProps> = ({ checked, onChange, label, id, ariaLabel }) => {
  const [hidden, setHidden] = useState<boolean>(checked)
  const resolvedAriaLabel = ariaLabel ?? (!label ? id : undefined)

  return (
    <FormControlLabel
      onClick={event => event.stopPropagation()}
      onFocus={event => event.stopPropagation()}
      style={{ marginLeft: 5 }}
      label={label ?? ''}
      control={
        <Checkbox
          data-testid={id ? `checkbox-field-${id}` : undefined}
          color="primary"
          icon={<CheckBoxOutlineBlank />}
          checkedIcon={<CheckBox />}
          slotProps={{
            input: {
              ...(resolvedAriaLabel && { 'aria-label': resolvedAriaLabel }),
            },
          }}
          checked={hidden}
          onChange={event => {
            onChange(event.target.checked)
            setHidden(!hidden)
          }}
        />
      }
    />
  )
}

export default RegularCheckbox
